import { render, staticRenderFns } from "./StarredList.vue?vue&type=template&id=1beb3ac0&scoped=true&"
import script from "./StarredList.vue?vue&type=script&lang=js&"
export * from "./StarredList.vue?vue&type=script&lang=js&"
import style0 from "./StarredList.vue?vue&type=style&index=0&id=1beb3ac0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1beb3ac0",
  null
  
)

export default component.exports